export default __webpack_public_path__ + "static/media/DNo.28-4.d0108896.jpg";